import nl from './lang/nl.json';
import en from './lang/en.json';
import be from './lang/be.json';

export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'nl',
  lazy: false,
  fallbackLocale: 'nl',
  locales: [
    {
      code: 'nl',
      iso: 'nl-NL',
    },
    {
      code: 'en',
      iso: 'en-EN',
    },
    {
      code: 'be',
      iso: 'be-BE',
    },
  ],
  messages: {
    nl,
    en,
    be,
  },
}));
